import {createStringXY as ol_createStringXY} from './../node_modules/ol/coordinate.js';
import {toStringXY as ol_toStringXY} from './../node_modules/ol/coordinate.js';

export const createStringXY = ol_createStringXY;
export const toStringXY = ol_toStringXY;